import { ACTION_AUTH } from '@/redux/auth/auth.action';
import { store } from '@/redux/store';
import axios from 'axios';
import { notify } from 'react-notify-toast';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const http = axios.create({
  baseURL: API_BASE_URL,
});

const getAuthConfig = () => {
  const { token } = store.getState().auth;
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isLoginEndpoint = error.config?.url?.includes('/auth/login');

      if (!isLoginEndpoint) {
        const message = error.response?.data?.message || 'Sesi Anda sudah berakhir';
        notify.show(message, 'error');

        store.dispatch(ACTION_AUTH.handleAuthExpiry(message));
      }
    }

    return Promise.reject(error);
  }
);

export default http;
export { API_BASE_URL, getAuthConfig };
